module.exports = __webpack_public_path__ + "assets/71d500ada0d2aa5b3282b53a98af5885.mp3";